<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="default"
  color="#7bff76"
  type="square-loader"
  [fullScreen]="false"
  ><p style="color: white">Loading...</p></ngx-spinner
>
<div class="content-wrapper"> 
  <div class="row mb-2">
    <div class="col-sm-12"> <br>
        <h1>  &nbsp; &nbsp;สรุปผลงาน</h1>
    </div>
  </div>

  <div class="row">
    
    <div class="col-md-3" *ngIf="sumsupportterdata != null">
      <div class="card card-primary card-outline">
          <div class="card-body box-profile">
              <div class="text-center">
                  <img class="profile-user-img img-fluid img-circle"
                      src="{{ userdata.suppic_url }}"
                      alt="User profile picture">
              </div>

              <h3 class="profile-username text-center">{{ userdata.supcode }} {{ userdata.supname }}</h3>

              <ul class="list-group list-group-unbordered mb-3" *ngFor="let item of sumsupportterdata">
                  <li class="list-group-item">
                      <div class="progress-group">
                          ปริมาณอ้อย
                          <span class="float-right"><b>{{item.Assess |number}}</b>/{{item.target_cane | number}}</span>
                          <div class="progress progress-sm">
                              <div class="progress-bar bg-warning" [ngStyle]="{width: item.pc_Assess+'%'}"></div>
                          </div>
                      </div>
                  </li>
                  <li class="list-group-item">
                      <div class="progress-group">
                          พื้นที่ปลูก
                          <span class="float-right"><b>{{item.sum_areas | number}}</b>/{{item.target_areas | number}}</span>
                          <div class="progress progress-sm">
                              <div class="progress-bar bg-primary"  [ngStyle]="{width: item.pc_sum_areas+'%'}"></div>
                          </div>
                      </div>
                  </li>
                  <li class="list-group-item">
                      <div class="progress-group">
                          ผลผลิต
                          <span class="float-right"><b>{{item.yield | number}}</b>/{{item.target_yield | number}}</span>
                          <div class="progress progress-sm">
                              <div class="progress-bar bg-success" [ngStyle]="{width: item.pc_yield+'%'}"></div>
                          </div>
                      </div>
                  </li>
              </ul>

          </div>
      </div>

      <div class="card card-primary" *ngIf="caninsupportterdata != null">
          <div class="card-header">
              <h3 class="card-title">อ้อยเข้าหีบ 64/65</h3>
          </div>
          <div class="card-body"  *ngFor="let item of caninsupportterdata">
              <strong><i class="fas fa-book mr-1"></i> ปริมาณอ้อย</strong>
              <div class="row">
                  <div class="col-5 center-content">
                    <canvas width="125" height="125" style="width: 100px; height: 100px;"></canvas>
                      <input type="text" class="knob" data-thickness="0.2" data-angleArc="250" minlength="0" maxlength="3"
                          data-angleOffset="-125" value="{{item.pc_canein| number}}" data-width="100" data-height="100"
                          data-fgColor="#FB914A"
                          style="width: 54px; height: 33px; position: absolute; vertical-align: middle; margin-top: 33px; margin-left: -77px; border: 0px; background: none; font: bold 20px Arial; text-align: center; color: rgb(251, 145, 74); padding: 0px; appearance: none;"
                          >
                      <!-- <div class="knob-label">data-angleArc="250"</div> -->
                  </div>
                  <div class="col-7 center-content">
                      <ul class="list-group list-group-unbordered mb-3">
                          <li class="list-group-item">
                              <b>ประเมิน</b> <a class="float-right">{{item.Assess_now | number}}</a>
                          </li>
                          <li class="list-group-item">
                              <b>เข้าหีบ</b> <a class="float-right">{{item.canein | number}}</a>
                          </li>
                      </ul>
                  </div>
              </div>

              <strong><i class="fas fa-hand-holding-heart mr-1"></i> ผลผลิต</strong>
              <div class="row">
                  <div class="col-5 center-content">
                    <canvas width="125" height="125" style="width: 100px; height: 100px;"></canvas>
                      <input type="text" class="knob" data-thickness="0.2" data-angleArc="250" minlength="0" maxlength="3"
                          data-angleOffset="-125" value="{{item.pc_yieldEnd| number}}" data-width="100" data-height="100"
                          data-fgColor="#FB914A"
                          style="width: 54px; height: 33px; position: absolute; vertical-align: middle; margin-top: 33px; margin-left: -77px; border: 0px; background: none; font: bold 20px Arial; text-align: center; color: rgb(251, 145, 74); padding: 0px; appearance: none;"

                          >
                      <!-- <div class="knob-label">data-angleArc="250"</div> -->
                  </div>
                  <div class="col-7 center-content">
                      <ul class="list-group list-group-unbordered mb-3">
                          <li class="list-group-item">
                              <b>เป้าหมาย</b> <a class="float-right">{{item.target_yield | number}}</a>
                          </li>
                          <li class="list-group-item">
                              <b>ผลงาน</b> <a class="float-right">{{item.yieldEnd | number}}</a>
                          </li>
                      </ul>
                  </div>
              </div>

              <div class="row">
                  <div class="col-12">
                      <div class="small-box bg-warning">
                          <div class="inner">
                              <h3>277</h3>
                          </div>
                          <div class="icon">
                              <i class="fab fa-facebook-f"></i>
                          </div>
                          <a href="#" class="small-box-footer">
                              แปลงตัดเสร็จ จาก <strong> 355 </strong> แปลง <i
                                  class="fas fa-arrow-circle-right"></i>
                          </a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>


    <div class="col-md-9"> <br> 
      <ul class="nav nav-pills ml-auto">
        <li class="nav-item" (click)="tab=1">
        <a [ngClass]="{'nav-link':true ,'active': tab==1 }" data-toggle="tab">
          <i class="	fas fa-tractor"></i> กิจกรรมแปลง</a>
        </li>
        <li class="nav-item" (click)="tab=2" > 
        <a [ngClass]="{'nav-link':true ,'active': tab==2}"  data-toggle="tab"><i class="far fa-address-card"> KPI</i></a>
        </li>
      </ul>
       
        <div class="tab-content">
          <div [ngClass]="{'tab-pane':true ,'active': tab==1 }"  *ngIf="tab == 1" id="tab_1">
              <div class="container-fluid bg-white"  *ngFor="let item of sumsupportterdata">
                  <div class="row">
                      <div class="col-sm-12">
                          <div class="info-box">
                              <span class="info-box-icon bg-info"><i class="fas fa-tree"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">จำนวนแปลงทั้งสิ้น</span>
                                  <span class="info-box-number">{{item.cnt_p}}</span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="	fas fa-tractor mr-1 mb-2"></i> ระเบิดดินดาน</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.hardSoilBlast}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar"  [ngStyle]="{width: item.pc_hardSoilBlast+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                     {{item.pc_hardSoilBlast}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ ภายใน 60 วัน</span>
                                  <span class="info-box-number">{{item.hardSoilBlast_60}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_hardSoilBlast_60+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_hardSoilBlast_60}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="	fas fa-align-justify mr-1 mb-2"></i> ระยะร่อง อ้อยปลูกใหม่</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.Germination_pc}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_Germination_pc+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_Germination_pc}} % จากแปลงอ้อยใหม่
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ มากกว่า150ซม.</span>
                                  <span class="info-box-number">{{item.Groove}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_Groove+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_Groove}} % จากแปลงอ้อยใหม่
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="fas fa-chess-board mr-1 mb-2"></i> โดโลไมท์</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.AmountDolomite}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountDolomite+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_AmountDolomite}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ ภายใน60วัน</span>
                                  <span class="info-box-number">{{item.AmountDolomite_60}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountDolomite60+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                      {{item.pc_AmountDolomite60}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="fas fa-truck-loading mr-1 mb-2"></i> ปุ๋ยอินทรีย์</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.AmountNatural}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountNatural+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                      {{item.pc_AmountNatural}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ ภายใน 60 วัน</span>
                                  <span class="info-box-number">{{item.AmountNatural_60}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountNatural_60+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_AmountNatural_60}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="fas fa-braille mr-1 mb-2"></i> % การงอก</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.Germination_pc}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_Germination_pc+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_Germination_pc}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>
<!-- 
                  <strong><i class="fas fa-seedling mr-1 mb-2"></i> วัชพืช</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">410 แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" style="width: 29%"></div>
                                  </div>
                                  <span class="progress-description">
                                      29%
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div> -->

                  <strong><i class="fa fa-check mr-1 mb-2"></i> เคมี 1</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.AmountFertilizer}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountFertilizer+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                      {{item.pc_AmountFertilizer}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ ภายใน 30 วัน</span>
                                  <span class="info-box-number">{{item.AmountFertilizer_30}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountFertilizer_30+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_AmountFertilizer_30}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>

                  <strong><i class="fa fa-check mr-1 mb-2"></i> เคมี 2</strong>
                  <div class="row">
                      <div class="col-sm-6">
                          <div class="info-box bg-info">
                              <span class="info-box-icon"><i class="fas fa-align-center"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงปริมาณ</span>
                                  <span class="info-box-number">{{item.AmountFertilizer2}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountFertilizer2+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                      {{item.pc_AmountFertilizer2}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                      <div class="col-sm-6">
                          <div class="info-box bg-warning">
                              <span class="info-box-icon"><i class="	fas fa-star-half-alt"></i></span>
                              <div class="info-box-content">
                                  <span class="info-box-text">เชิงคุณภาพ ภายใน 30 วัน</span>
                                  <span class="info-box-number">{{item.AmountFertilizer2_60}} แปลง</span>
                                  <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{width: item.pc_AmountFertilizer2_60+'%'}"></div>
                                  </div>
                                  <span class="progress-description">
                                    {{item.pc_AmountFertilizer2_60}} %
                                  </span>
                              </div>
                              <!-- /.info-box-content -->
                          </div>
                      </div>
                  </div>


              </div>

          </div>

          <div [ngClass]="{'tab-pane':true ,'active': tab==2 }" *ngIf="tab == 2" id="tab_2">
              <div class="row">
                  <div class="col-12 table-responsive">
                      <table class="table table-striped">
                          <thead>
                              <tr>
                                  <th>Qty</th>
                                  <th>Product</th>
                                  <th>Serial #</th>
                                  <th>Description</th>
                                  <th>Subtotal</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>1</td>
                                  <td>Call of Duty</td>
                                  <td>455-981-221</td>
                                  <td>El snort testosterone trophy driving gloves handsome</td>
                                  <td>$64.50</td>
                              </tr>
                              <tr>
                                  <td>1</td>
                                  <td>Need for Speed IV</td>
                                  <td>247-925-726</td>
                                  <td>Wes Anderson umami biodiesel</td>
                                  <td>$50.00</td>
                              </tr>
                              <tr>
                                  <td>1</td>
                                  <td>Monsters DVD</td>
                                  <td>735-845-642</td>
                                  <td>Terry Richardson helvetica tousled street art master</td>
                                  <td>$10.70</td>
                              </tr>
                              <tr>
                                  <td>1</td>
                                  <td>Grown Ups Blue Ray</td>
                                  <td>422-568-642</td>
                                  <td>Tousled lomo letterpress</td>
                                  <td>$25.99</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <!-- /.col -->
              </div>
              <!-- /.row -->

              <div class="row">
                  <!-- accepted payments column -->
                  <div class="col-6">
                      <p class="lead">Payment Methods:</p>
                      <img src="../../dist/img/credit/visa.png" alt="Visa">
                      <img src="../../dist/img/credit/mastercard.png" alt="Mastercard">
                      <img src="../../dist/img/credit/american-express.png" alt="American Express">
                      <img src="../../dist/img/credit/paypal2.png" alt="Paypal">

                      <p class="text-muted well well-sm shadow-none" style="margin-top: 10px;">
                          Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya
                          handango imeem
                          plugg
                          dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra.
                      </p>
                  </div>
                  <!-- /.col -->
                  <div class="col-6">
                      <p class="lead">Amount Due 2/22/2014</p>

                      <div class="table-responsive">
                          <table class="table">
                              <tr>
                                  <th style="width:50%">Subtotal:</th>
                                  <td>$250.30</td>
                              </tr>
                              <tr>
                                  <th>Tax (9.3%)</th>
                                  <td>$10.34</td>
                              </tr>
                              <tr>
                                  <th>Shipping:</th>
                                  <td>$5.80</td>
                              </tr>
                              <tr>
                                  <th>Total:</th>
                                  <td>$265.24</td>
                              </tr>
                          </table>
                      </div>
                  </div>
                  <!-- /.col -->
              </div>
              <!-- /.row -->

              <!-- this row will not appear when printing -->
              <div class="row no-print">
                  <div class="col-12">
                      <a href="invoice-print.html" target="_blank" class="btn btn-default"><i
                              class="fas fa-print"></i> Print</a>
                      <button type="button" class="btn btn-success float-right"><i
                              class="far fa-credit-card"></i> Submit
                          Payment
                      </button>
                      <button type="button" class="btn btn-primary float-right" style="margin-right: 5px;">
                          <i class="fas fa-download"></i> Generate PDF
                      </button>
                  </div>
              </div>
          </div>
        </div>
     
    </div>
  </div>
 
</div>
<app-footer></app-footer>
